// extracted by mini-css-extract-plugin
export default {"inviteHeaderButton":"ParticipantsMenu_inviteHeaderButton__me8NW","inviteIcon":"ParticipantsMenu_inviteIcon__gEfUf"};